export const preloadedValues = {
  operPISSCST: "01",
  operPISDeduzICMS: false,
  operCOFINSCST: "01",
  operCOFINSDeduzICMS: false,

};
